/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown> }} Featured_HourInputs */

const en_featured_hour = /** @type {(inputs: Featured_HourInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("en", i?.number, {});
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`${i?.number} hour`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`${i?.number} hours`);
	return /** @type {LocalizedString} */ (`${i?.number} hours`)
	
};

const ar_featured_hour = /** @type {(inputs: Featured_HourInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("ar", i?.number, {});
	if (numberPlural == "zero") return /** @type {LocalizedString} */ (`${i?.number} ساعة`);
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`${i?.number} ساعة`);
	if (numberPlural == "two") return /** @type {LocalizedString} */ (`${i?.number} ساعتان`);
	if (numberPlural == "few") return /** @type {LocalizedString} */ (`${i?.number} ساعات`);
	if (numberPlural == "many") return /** @type {LocalizedString} */ (`${i?.number} ساعةً`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`${i?.number} ساعة`);
	return /** @type {LocalizedString} */ (`${i?.number} ساعة`)
	
};

const de_featured_hour = /** @type {(inputs: Featured_HourInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("de", i?.number, {});
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`${i?.number} Stunde`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`${i?.number} Stunden`);
	return /** @type {LocalizedString} */ (`${i?.number} Stunden`)
	
};

const es_featured_hour = /** @type {(inputs: Featured_HourInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("es", i?.number, {});
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`${i?.number} hora`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`${i?.number} horas`);
	return /** @type {LocalizedString} */ (`${i?.number} horas`)
	
};

const fr_featured_hour = /** @type {(inputs: Featured_HourInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("fr", i?.number, {});
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`${i?.number} heure`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`${i?.number} heures`);
	return /** @type {LocalizedString} */ (`${i?.number} heures`)
	
};

const it_featured_hour = /** @type {(inputs: Featured_HourInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("it", i?.number, {});
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`${i?.number} ora`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`${i?.number} ore`);
	return /** @type {LocalizedString} */ (`${i?.number} ore`)
	
};

const ja_featured_hour = /** @type {(inputs: Featured_HourInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("ja", i?.number, {});
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`${i?.number}時間`);
	return /** @type {LocalizedString} */ (`${i?.number}時間`)
	
};

const ko_featured_hour = /** @type {(inputs: Featured_HourInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("ko", i?.number, {});
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`${i?.number}시간`);
	return /** @type {LocalizedString} */ (`${i?.number}시간`)
	
};

const pt_br_featured_hour = /** @type {(inputs: Featured_HourInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("pt_br", i?.number, {});
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`${i?.number} hora`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`${i?.number} horas`);
	return /** @type {LocalizedString} */ (`${i?.number} horas`)
	
};

const ru_featured_hour = /** @type {(inputs: Featured_HourInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("ru", i?.number, {});
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`${i?.number} час`);
	if (numberPlural == "few") return /** @type {LocalizedString} */ (`${i?.number} часа`);
	if (numberPlural == "many") return /** @type {LocalizedString} */ (`${i?.number} часов`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`${i?.number} часа`);
	return /** @type {LocalizedString} */ (`${i?.number} часа`)
	
};

const th_featured_hour = /** @type {(inputs: Featured_HourInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("th", i?.number, {});
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`${i?.number} ชั่วโมง`);
	return /** @type {LocalizedString} */ (`${i?.number} ชั่วโมง`)
	
};

const tr_featured_hour = /** @type {(inputs: Featured_HourInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("tr", i?.number, {});
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`${i?.number} saat`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`${i?.number} saat`);
	return /** @type {LocalizedString} */ (`${i?.number} saat`)
	
};

const zh_cn_featured_hour = /** @type {(inputs: Featured_HourInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("zh_cn", i?.number, {});
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`${i?.number} 小时`);
	return /** @type {LocalizedString} */ (`${i?.number} 小时`)
	
};

const zh_tw_featured_hour = /** @type {(inputs: Featured_HourInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("zh_tw", i?.number, {});
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`${i?.number} 小時`);
	return /** @type {LocalizedString} */ (`${i?.number} 小時`)
	
};

/**
* | numberPlural | output |
* | --- | --- |
* | "one" | "{number} hour" |
* | "other" | "{number} hours" |
* | * | "{number} hours" |
*
* @param {Featured_HourInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const featured_hour = /** @type {((inputs: Featured_HourInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Featured_HourInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_featured_hour(inputs)
	if (locale === "ar") return ar_featured_hour(inputs)
	if (locale === "de") return de_featured_hour(inputs)
	if (locale === "es") return es_featured_hour(inputs)
	if (locale === "fr") return fr_featured_hour(inputs)
	if (locale === "it") return it_featured_hour(inputs)
	if (locale === "ja") return ja_featured_hour(inputs)
	if (locale === "ko") return ko_featured_hour(inputs)
	if (locale === "pt_br") return pt_br_featured_hour(inputs)
	if (locale === "ru") return ru_featured_hour(inputs)
	if (locale === "th") return th_featured_hour(inputs)
	if (locale === "tr") return tr_featured_hour(inputs)
	if (locale === "zh_cn") return zh_cn_featured_hour(inputs)
	return zh_tw_featured_hour(inputs)
});